import React from 'react';
import './Home.scss';
import Navbar from '../../components/Navbar/Navbar';
import Appointment from '../../components/Appointment/Appointment';
import Banner from './sections/Banner/Banner';
import Blogs from './sections/Blogs/Blogs';
import Features from './sections/Features/Features';
import Footer from '../../components/Footer/Footer';
import Services from './sections/Services/Services';
import Testimonial from './sections/Testimonial/Testimonial';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { Helmet } from 'react-helmet-async';
import {Divider} from '../../components/Divider';


export const Home = () => {

    return (
        <>
            <Helmet>
                <title>Złota Centrum Zdrowia | Strona główna</title>
                <meta
                  name="description"
                  content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                />
                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:title" content="Złota Centrum Zdrowia | Strona główna" />
                <meta
                  property="og:description"
                  content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                />
        
                {/* Twitter */}
                <meta property="twitter:card" content="summary" />
                <meta property="twitter:url" content={window.location.href} />
                <meta property="twitter:title" content="Złota Centrum Zdrowia | Strona główna" />
                <meta
                  property="twitter:description"
                  content="Nasze Centrum Zdrowia to nowoczesna placówka, która łączy profesjonalizm, doświadczenie oraz indywidualne podejście do każdego pacjenta."
                />
              </Helmet>
            <Navbar/>
            <Banner/>
        <Services />
        <Divider />
            <Features />
            <div className="container row home-title-container section-p">
                <SectionTitle mainHeading={true} title="Wspólne miejsce dla Zdrowia" />
                <p className='section-title-text'>
                Złota Centrum Zdrowia powstało z myślą o pacjentach, którzy cenią sobie fachową opiekę medyczną, wygodę oraz komfortowe warunki leczenia. Naszym celem jest zapewnienie wszechstronnej diagnostyki i leczenia w jednym miejscu, w dogodnej lokalizacji.            </p>
            </div>
            <Testimonial/>
        <Blogs />
            <Appointment />
            <Footer/>
        </>
    );
};